/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-28T14:19:44.596
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialCollectionDetail,
	listFinancialCollectionDetailInit,
	listFinancialCollectionDetailByAuthorizations,
	deleteFinancialCollectionDetail
} from '@api/financial/FinancialCollectionDetail';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialCollectionDetail({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionDetail(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialCollectionDetailByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionDetailByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialCollectionDetailInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialCollectionDetailInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialCollectionDetail({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialCollectionDetail({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
